import { useEffect, useState } from "react";

interface ContactLinkProps {
  type: "tel" | "mailto" | "whatsapp";
  value?: string;
  label: string;
  func: (str:string)=>void;
}

const ContactLink: React.FC<ContactLinkProps> = ({ type, value, label, func}) => {

  if (!value) return null;

  const formatNumber = (num: string) => {
    let digits = num.replace(/\D/g, "");
    if (digits.length === 10 && digits.startsWith("3")) {
      digits = "+39" + digits;
    }
    return digits;
  };

  let href = "";
  if (type === "tel") {
    href = `${formatNumber(value)}`;
  } else if (type === "mailto") {
    href = `${value}`;
  }

  return (
    <p>
      {label}:{" "}
        <a onClick={()=>func(href)} className=" link-text">
          {value}
        </a>
    </p>
  );
};
export default ContactLink;
